import { render, staticRenderFns } from "./BimDatabankData.vue.html?vue&type=template&id=597c9eba&scoped=true&lang=html&external"
import script from "./BimDatabankData.vue.js?vue&type=script&lang=js&external"
export * from "./BimDatabankData.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDatabankData.vue.scss?vue&type=style&index=0&id=597c9eba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c9eba",
  null
  
)

export default component.exports